// The legacy gene.codes app signs its users in itself (decision 2026-10-01): no platform credential is ever sent there.
export const GENE_CODES_URL = "https://gene.codes/";

// noopener: the gene.codes tab gets no handle on this window.
export const openGeneCodes = (): void => {
	window.open(GENE_CODES_URL, "_blank", "noopener,noreferrer");
};
